export enum SizerMode {
    Left, Top, Right, Bottom, LeftTop, RightTop, LeftBottom, RightBottom
}